import React from "react";
import { Pagination, PlainButton } from "@culturehq/components";

import { useQueryString } from "app/context";
import { Trans } from "app/utils";

import PersonCard from "./PersonCard";
import PersonPlaceholder from "./PersonPlaceholder";

const PeopleCardsGrid = ({ loading, onSelected, onUnselected, users, sortable }) => {
  if (loading) {
    return [1, 2, 3, 4, 5, 6, 7, 8].map(index => <PersonPlaceholder key={index} />);
  }

  return users.map(user => (
    <PersonCard
      key={user.id}
      person={user}
      onSelected={onSelected}
      onUnselected={onUnselected}
      sortable={sortable}
    />
  ));
};

const PeopleCardsEmpty = () => {
  const { onClearQueryString } = useQueryString();

  return (
    <div className="EmptyResults EmptyResults-people">
      <h2><Trans>Oh no, you ran out of results...</Trans></h2>
      <PlainButton onClick={onClearQueryString}>
        <Trans>Start over</Trans>
      </PlainButton>
    </div>
  );
};

const PeopleCardsItems = ({ loading, onSelected, onUnselected, users, sortable }) => {
  if (!loading && users.length === 0) {
    return <PeopleCardsEmpty />;
  }

  return (
    <PeopleCardsGrid
      loading={loading}
      onSelected={onSelected}
      onUnselected={onUnselected}
      users={users}
      sortable={sortable}
    />
  );
};

const PeopleCards = ({
  loading, onSelected, onUnselected, onPageSelected, pagination, users, sortable = false
}) => {
  if (sortable) {
    return (
      <PeopleCardsItems
        loading={loading}
        onSelected={onSelected}
        onUnselected={onUnselected}
        users={users}
        sortable={sortable}
      />
    );
  }

  return (
    <>
      <div className="clearfix">
        <PeopleCardsItems
          loading={loading}
          onSelected={onSelected}
          onUnselected={onUnselected}
          users={users}
        />
      </div>
      <Pagination {...pagination} onClick={onPageSelected} />
    </>
  );
};

export default PeopleCards;
